import { YesNoToggle } from "./YesNoToggle";

export default YesNoToggle;
